<template>
    <div class="f--c">
        <div class="statusBox p-r fd-c " v-if="isPC">
            <div class="bigStatus orderTag f" :class="{[showStatus]: true}">{{ showText }}</div>
            <div class="smallStatus refund_tag orderTag f" v-if="(order.refundStatus && order.refundStatus !== 'NULL')">{{ refundText }}</div>
        </div>
        <div v-else class="f--c statusBox_mobile">
            <div :class="{[showStatus]: true}" class="bigStatus orderTag f--c">{{showText}}</div>
            <!-- <div class="smallStatus refund_tag orderTag f--c" v-if="(order.refundStatus && order.refundStatus !== 'NULL')">{{ refundText }}</div> -->
        </div>
    </div>
</template>

<script>

export default {
  props: {
    order: {
      type: Object,
      default: () => ({
        financialStatus: 'NULL',
        fulfillmentStatus: 'NULL',
        status: 'NULL',
        refundStatus: 'NULL'
      }),
      required: true
    }
  },
  computed: {
    showText() {
      const statusMap = {
        waiting_payment: `${this.$t('Order.List.Components.OrderStatusTag.WaitingPayment')}`,
        completed: `${this.$t('Order.List.Components.OrderStatusTag.Complete')}`,
        cancel: `${this.$t('Order.List.Components.OrderStatusTag.Cancel')}`,
        waiting_to_ship: `${this.$t('Order.List.Components.OrderStatusTag.WaitingToShip')}`,
        fully_shipped: `${this.$t('Order.List.Components.OrderStatusTag.FullyShipped')}`,
        partial_shipped: `${this.$t('Order.List.Components.OrderStatusTag.PartialShipped')}`,
        abnormal_order: `${this.$t('Order.List.Components.OrderStatusTag.AbnormalOrder')}`
      }
      return statusMap[this.showStatus]
    },
    showStatus() {
      if (['waiting_payment', 'completed', 'cancel'].includes(this.order.status)) return this.order.status
      if (this.order.status === 'abnormal_order') return this.order.status // this.order.financialStatus
      if (this.order.status === 'processing') return this.order.fulfillmentStatus
      return 'NULL'
    },
    refundText() {
      if (this.order.refundStatus !== 'NULL') {
        const statusMap = {
          refunding: `${this.$t('Order.List.Components.OrderStatusTag.Refunding')}`,
          partial_refund: `${this.$t('Order.List.Components.OrderStatusTag.PartialRefund')}`,
          refunded: `${this.$t('Order.List.Components.OrderStatusTag.Refunded')}`
        }
        return statusMap[this.order.refundStatus]
      }
      return ''
    }
  },
  methods: {
    statusFontColor(order) {

    }
  }
}
</script>

<style lang="scss" scoped>
.statusBox{
    width: 180px;
    .orderTag::before {
        content: '';
        display: inline-block;
        margin: 0 8px 2px 0;
        width: 4px;
        height: 4px;
        line-height: 28px;
        border-radius: 100%;
    }
    .orderTag{
        border-radius: 20px;
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 400;
        display: inline-block;
        margin-bottom: 4px;
    }
}
.statusBox_mobile{
    // padding: .2rem .3rem;\
    .orderTag::before {
        content: '';
        display: inline-block;
        margin: 0 8px 2px 0;
        width: 4px;
        height: 4px;
        line-height: 28px;
        border-radius: 100%;
    }
    .orderTag{
        border-radius: 20px;
        font-size: 14px;
        font-weight: 400;
        // height: 40px;
        // line-height: 40px;
        padding: .2rem .3rem;
    }
}
.waiting_payment{
    background-color: #FFF6EE;
    color: #F9973C;
}
.waiting_payment::before {
    background-color: #F9973C;
}
.completed{
    background: rgba(153, 196, 28, 0.14);
    color: #99C41C;
}
.completed::before{
    background-color: #99C41C;
}
.cancel{
    background-color: rgba(116, 122, 135, 0.1);
    color: #747A87;
}
.cancel::before{
    background-color: #747A87;
}
.waiting{
    background-color: #FFF6EE;
    color: #F9973C;
}
.waiting::before{
    background-color: #F9973C;
}
.waiting_to_ship{
    background-color: rgba(149, 58, 192, 0.1);
    color: #953AC0;
}
.waiting_to_ship::before{
    background-color: #953AC0;
}
.fully_shipped{
    background-color: rgba(179, 97, 71, 0.15);
    color: #B15A44;
}
.fully_shipped::before{
    background-color: #B15A44;
}
.partial_shipped{
    background-color: #E9F2FF;
    color: #296AC7;
}
.partial_shipped::before{
    background-color: #296AC7;
}
.refund_tag, .abnormal_order{
    background-color: rgba(229, 51, 83, 0.06);
    color: #E53353;
}
.refund_tag::before, .abnormal_order::before{
    background-color: #E53353;
}
</style>
